import React from 'react';
import Localidades from '../../../api/localidades';
import Provincias from '../../../api/provincias';

const DatosFacturacion = (props) => {
  const localidad = Localidades.filter(({ id }) => id.toString() === props.datosFacturacion.localidad.toString());
  const provincia = Provincias.filter(({ id }) => id.toString() === props.datosFacturacion.provincia.toString());

  return (
    <div className='panel panel-default custom bordeado datos-facturacion'>
      <div className='panel-body'>
        <div className='row'>
          <div className='col-md-6'>
            <h2 className='titulo-panel'>Datos de facturación</h2>
            <p>
              <span>
                <b>Nombre: </b>
                {' '}
                <span>{`${props.datosFacturacion.nombre} ${props.datosFacturacion.apellido}`}</span>
              </span>
              <br />
              <span>
                DNI:
                <span>{props.datosFacturacion.nro_documento}</span>
              </span>
              <br />
              <span>
                Direccion:
                <span>{props.datosFacturacion.direccion}</span>
              </span>
              <br />
              <span>
                Localidad:
                <span>{localidad[0] !== undefined ? localidad[0].descripcion : ''}</span>
              </span>
              <br />
              <span>
                Provincia:
                <span>{provincia[0] !== undefined ? provincia[0].descripcion : ''}</span>
              </span>
              <br />
              <span>
                Telefono:
                <span>{props.datosFacturacion.telefono}</span>
              </span>
            </p>
          </div>

          <div className='col-md-6'>
            <div>
              <h2 className='titulo-panel'>
                <b>
                  {' '}
                  Número de reserva:
                  {props.reservaId}
                </b>
              </h2>
              <p>
                Con este codigo podras identificar tu reserva.
              </p>
            </div>
            <h2 className='titulo-panel'>Datos de contacto</h2>
            <div>
              <b>Email: </b>
              {' '}
              <span>
                {' '}
                {props.datosContacto.email}
              </span>
            </div>
            <div>
              <b>Telefono: </b>
              {' '}
              <span>
                {' '}
                {props.datosContacto.telefono}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DatosFacturacion;
